import styled from "styled-components";

const List = styled.div`
  padding: 0;
  margin: 0 16px;
`;

export { List };
